import { type IntlShape } from 'react-intl';

import getUserRecommendations from '@atlaskit/smart-user-picker/recommendation-client';
import type { OptionData } from '@atlaskit/user-picker/types';

type ProductKeyType = 'confluence';

type GetOwnersProps = {
	cloudId: string;
	intl: IntlShape;
	maxNumberOfResults: number;
	productKey: ProductKeyType;
	query: string;
	userId: string;
};

export const getOwners = ({
	query,
	userId,
	cloudId,
	productKey,
	maxNumberOfResults,
	intl,
}: GetOwnersProps): Promise<OptionData[]> => {
	const requestParams = {
		context: {
			contextType: 'owners',
			principalId: userId,
			productAttributes: {
				isEntitledConfluenceExternalCollaborator: true,
			},
			productKey,
			siteId: cloudId,
		},
		includeGroups: false,
		includeTeams: false,
		includeUsers: true,
		maxNumberOfResults,
		performSearchQueryOnly: false,
		query,
	};

	return getUserRecommendations(requestParams, intl);
};
